/** Same authority as MeasureController::update / deleteImage. */
export function canDeleteDocumentationAttachment(user) {
    const permissions = user?.permissions;
    if (!permissions || typeof permissions.includes !== "function") return false;
    return permissions.includes("edit otk-section2") || permissions.includes("edit otk-section3");
}
